function controlLabel(range){
  const heading=range.closest('label')?.querySelector(':scope > span');
  if(!heading)return 'Valor numérico';
  const copy=heading.cloneNode(true);
  copy.querySelectorAll('output').forEach((output)=>output.remove());
  return copy.textContent.trim()||'Valor numérico';
}

function clamp(value,min,max){
  return Math.min(max,Math.max(min,value));
}

function enhanceRange(range){
  if(range.dataset.numberControl==='ready')return;
  range.dataset.numberControl='ready';

  const wrapper=document.createElement('span');
  wrapper.className='range-number-control';
  range.before(wrapper);
  wrapper.append(range);

  const number=document.createElement('input');
  number.type='number';
  number.className='range-number-input';
  number.value=range.value;
  number.inputMode='decimal';
  number.setAttribute('aria-label',`${controlLabel(range)}: valor manual`);
  number.title=`Mínimo ${range.min} · máximo ${range.max} · paso ${range.step||1}`;
  for(const attribute of ['min','max','step']){
    if(range.hasAttribute(attribute))number.setAttribute(attribute,range.getAttribute(attribute));
  }
  wrapper.append(number);

  let updatingFromNumber=false;
  const syncNumber=()=>{
    if(!updatingFromNumber&&document.activeElement!==number){
      number.value=range.value;
    }
  };
  range.syncNumberControl=syncNumber;
  range.addEventListener('input',syncNumber);
  range.addEventListener('change',syncNumber);

  const applyNumber=(final=false)=>{
    const raw=number.value.trim();
    const parsed=Number(raw);
    const minimum=range.min===''?Number.NEGATIVE_INFINITY:Number(range.min);
    const maximum=range.max===''?Number.POSITIVE_INFINITY:Number(range.max);
    if(raw===''||!Number.isFinite(parsed)){
      if(final)number.value=range.value;
      return;
    }
    if(!final&&(parsed<minimum||parsed>maximum))return;
    const next=clamp(parsed,minimum,maximum);
    updatingFromNumber=true;
    range.value=String(next);
    range.dispatchEvent(new Event('input',{bubbles:true}));
    updatingFromNumber=false;
    if(final)number.value=range.value;
  };

  number.addEventListener('input',()=>applyNumber(false));
  number.addEventListener('change',()=>applyNumber(true));
  number.addEventListener('blur',()=>applyNumber(true));
  number.addEventListener('keydown',(event)=>{
    if(event.key==='Enter'){
      event.preventDefault();
      applyNumber(true);
      number.blur();
    }
    if(event.key==='Escape'){
      event.preventDefault();
      number.value=range.value;
      number.blur();
    }
  });
}

export function installRangeNumberControls(root=document){
  root.querySelectorAll('input[type="range"]').forEach(enhanceRange);
}

installRangeNumberControls();
